import { useLocation, useNavigate } from "react-router";
import { CTACategoryList } from "../../components/Constants";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import NavBarTitles from "../../components/Common/TabBar";

const CTAHeader = ({ type }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const addNewCTABanner = {
    id: "addnewpost",
    onClick: () =>
      navigate(
        `/cta-banner/${location.pathname.split("/")[2]}/add-new-cta-banner`,
      ),
    style: { width: "240px" },
    label: "Add New CTA Banner",
  };
  const currentSlug = location.pathname.split("/")[2];

  const currentCategory = CTACategoryList.find(
    (data) => data?.slugurl === currentSlug,
  );

  const breadcrumbsList = [
    {
      text: `CTA / ${type}`,
      link:
        type === "Form"
          ? `/cta-form/retail-pharmacies`
          : `/cta-banner/retail-pharmacies`,
    },
    { text: currentCategory ? currentCategory.name : "", link: "" },
  ];

  const CTACategoryTab = CTACategoryList.map((item) => ({
    name: item.name,
    navigatePath:
      type === "Form"
        ? `/cta-form/${item.slugurl}`
        : `/cta-banner/${item.slugurl}`,
  }));

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs pb-2"
          breadcrumbsList={breadcrumbsList}
        />
        {type === "Banner" && <FilledButton props={addNewCTABanner} />}
      </div>
      <div className="my-3">
        <NavBarTitles titles={CTACategoryTab} />
      </div>
    </>
  );
};

export default CTAHeader;
